import trafficSourceToggle from '@/services/components/trafficSourceToggle.vue'

export default {
  components: {
    'v-traffic-source-toggle': trafficSourceToggle
  }
}
